// extracted by mini-css-extract-plugin
export default {"submitBtn":"ZqTKGOxcj4SZeUI3OVen"};